import { render, staticRenderFns } from "./ActivityEdit.vue?vue&type=template&id=81f83282&"
import script from "./ActivityEdit.vue?vue&type=script&lang=js&"
export * from "./ActivityEdit.vue?vue&type=script&lang=js&"
import style0 from "./ActivityEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports